import { FILTER_KEYS, INVOICE_FILTER_OPTIONS } from "src/util/enums/invoice-management";
import { ValidatorTypes } from "../util/validators";


export const taskFields = {
  taskName: {
    name: 'taskName',
    label: 'Task Name',
    type: 'text',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED]
  },
  section: {
    name: 'section',
    label: 'Section',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: '',
    items: [],
    validation: [ValidatorTypes.REQUIRED]
  },
  profitMarginType: {
    name: 'profitMarginType',
    label: 'Profit Margin Type',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: 'PERCENTAGE',
    items: [
      { key: 'Percentage', value: 'PERCENTAGE' }],
    validation: [ValidatorTypes.REQUIRED]
  },
  profitMargin: {
    name: 'profitMargin',
    label: 'Profit Margin %',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: []
  },
  description: {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.TEXTAREA]
  },
  notes: {
    name: 'notes',
    label: 'Internal notes',
    type: 'textarea',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.TEXTAREA]
  },
  attachments: {
    name: 'attachments',
    label: 'Attachments',
    type: 'file',
    touched: false,
    error: false,
    valid: true,
    multiple: true,
    value: [],
    attachmentArr: [],
    validation: []
  },
  is_actual_materialcost: {
    name: 'is_actual_materialcost',
    label: 'Use Material Cost as Actual Cost',
    type: 'checkbox',
    touched: false,
    error: false,
    valid: true,
    validation: [ValidatorTypes.OPTIONAL]
  },
  date: {
    name: 'date',
    label: '',
    type: 'datepicker',
    touched: false,
    error: false,
    value: new Date()
  },
  user: {
    name: 'user',
    type: 'select',
    label: 'Select User',
    value: '',
    validation: [ValidatorTypes.OPTIONAL]
  }
}
export const subTaskFields = {
  taskName: {
    name: 'taskName',
    label: 'Task Name',
    type: 'text',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED]
  },
  section: {
    name: 'section',
    label: 'Section',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: '',
    items: [],
    validation: [ValidatorTypes.REQUIRED]
  },
  description: {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.TEXTAREA]
  },
  notes: {
    name: 'notes',
    label: 'Internal notes',
    type: 'textarea',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.TEXTAREA]
  },
  is_actual_materialcost: {
    name: 'is_actual_materialcost',
    label: 'Use Material Cost as Actual Cost',
    type: 'checkbox',
    touched: false,
    error: false,
    valid: true,
    validation: [ValidatorTypes.OPTIONAL]
  }
}
export const itemFields = {
  name: {
    value: ''
  },
  id: '',
  categoryId: '',
  taskId: {
    name: 'taskId',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: '',
    items: []
  },
  manufacturer: '',
  partNo: '',
  costPerItem: {
    name: 'costPerItem',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  saleAmount: {
    name: 'saleAmount',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  qty: {
    name: 'qty',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  unit: {
    name: 'unit',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: 'unit',
    items: []
  },
  saleAmountLock: {
    name: 'saleAmountLock',
    type: 'boolean',
    touched: false,
    error: false,
    valid: true,
    value: true
  },
  total: {
    value: 0
  }
}

export const laborObjFields = {
  name: {
    name: 'name',
    label: '',
    type: 'text',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED]
  },
  id: {
    value: ''
  },
  skillDescription: {
    value: ''
  },
  calloutCost: {
    name: 'calloutCost',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  travelCost: {
    name: 'travelCost',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  level: {
    name: 'level',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: '',
    items: []
  },
  labourCost: {
    name: 'labourCost',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  costPerItem: {
    name: 'costPerItem',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  qty: {
    name: 'qty',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  is_personnel: {
    value: true
  },
  total: {
    value: 0
  }
}
export const subcontractorObjFields = {
  name: {
    name: 'name',
    label: 'Contractor Name',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: '',
    items: []
  },
  id: {
    value: ''
  },
  isUnassigned: {
    value: true
  },
  Cost: {
    name: 'Cost',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  subContractorForecastCost: {
    name: 'subContractorForecastCost',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  saleAmount: {
    name: 'saleAmount',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: 0
  },
  saleAmountLock: {
    name: 'saleAmountLock',
    type: 'boolean',
    touched: false,
    error: false,
    valid: true,
    value: true
  },
  description: {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.TEXTAREA]
  },
  total: {
    value: 0
  }
}
export const categoriesFields = {
  name: 'categories',
  label: 'Catalog',
  type: 'select',
  items: [],
  value: ''
}

export const categoryItemFields = {
  name: 'items',
  type: 'select',
  label: 'Add Item',
  items: [],
  value: ''
}

export const viewDataFields = {
  name: '',
  description: '',
  profitMargin: 0,
  profitMarginType: '',
  totalCost: 0,
  noOfItems: 0,
  noOfResources: 0,
  material: [],
  labor: []
}

export const sectionFields = {
  sectionName: {
    name: 'sectionName',
    label: 'Section Name',
    type: 'text',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED]
  },
  description: {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.TEXTAREA]
  },
  profitMarginType: {
    name: 'profitMarginType',
    label: 'Profit Margin Type',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: 'PERCENTAGE',
    items: [{ key: 'Fixed', value: 'FIXED' },
    { key: 'Percentage', value: 'PERCENTAGE' }],
    validation: [ValidatorTypes.REQUIRED]
  },
  profitMargin: {
    name: 'profitMargin',
    label: 'Profit Margin',
    type: 'number',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: []
  },
  // variableAmount: {
  //   name: 'variableAmount',
  //   label: 'Sub-Contractor Cost',
  //   type: 'text',
  //   touched: false,
  //   error: false,
  //   valid: true,
  //   value: '',
  //   validation: [ValidatorTypes.REQUIRED]
  // },
  // variableAmountDescription: {
  //   name: 'variableAmountDescription',
  //   label: 'Sub-Contractor Cost Description',
  //   type: 'textarea',
  //   touched: false,
  //   error: false,
  //   valid: true,
  //   value: '',
  //   validation: [ValidatorTypes.REQUIRED]
  // },
  attachments: {
    name: 'attachments',
    label: 'Attachments',
    type: 'file',
    touched: false,
    error: false,
    valid: true,
    multiple: true,
    value: [],
    attachmentArr: [],
    validation: []
  }
}

export const viewDataStageFields = {
  name: '',
  description: '',
  totalCost: '',
  ProfitMargin: '',
  totalTasks: ''
}

export const levelFields = {
  name: {
    name: 'name',
    label: 'Level Name',
    type: 'text',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED]
  },
  description: {
    name: 'description',
    label: 'Level Description',
    type: 'textarea',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED, ValidatorTypes.TEXTAREA]
  },
  calloutCost: {
    name: 'calloutCost',
    label: 'Call Out Charge Amount',
    type: 'amount',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.NUMBER]
  },
  calloutAverageCost: {
    name: 'calloutAverageCost',
    label: 'Average Cost',
    type: 'amount',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.NUMBER]
  },
  travelCost: {
    name: 'travelCost',
    label: 'Travel Charge Amount',
    type: 'amount',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.NUMBER]
  },
  travelAverageCost: {
    name: 'travelAverageCost',
    label: 'Average Cost',
    type: 'amount',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.NUMBER]
  }
}

export const addTemplateFields = {
  name: {
    name: 'name',
    label: 'Template Name',
    type: 'text',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED]
  },
  description: {
    name: 'description',
    label: 'Description',
    type: 'textarea',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED, ValidatorTypes.TEXTAREA]
  }
}

export const assignTaskFields = {
  status: {
    error: false,
    valid: true,
    value: 'OPEN'
  },
  percentageComplete: {
    error: false,
    valid: true,
    value: ''
  },
  reminder: {
    error: false,
    valid: true,
    value: ''
  },
  attachments: {
    error: false,
    valid: true,
    value: [],
    attachmentArr: [],
    validation: [{ type: ValidatorTypes.FILE, max: 10 }]
  }
}

export const deliveryOptions = [
  { key: 'Office', value: 'OFFICE' },
  { key: 'Pickup', value: 'PICKUP' },
  { key: 'Site', value: 'SITE' }
];

export const projectCategoryFields = {
  name: {
    name: 'name',
    label: 'Name',
    type: 'text',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PROJECT_TYPE_NAME]
  },
  type: {
    name: 'type',
    label: 'Type',
    type: 'text',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PROJECT_TYPE_CODE]
  },

}

export const projectCategoryDeleteFields = {
  password: {
    name: 'password',
    label: 'Password',
    type: 'password',
    touched: false,
    error: false,
    valid: true,
    value: '',
    validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PROJECT_TYPE_PASSWORD]
  },
  selectedType: {
    name: 'selectedType',
    label: 'Code',
    type: 'select',
    touched: false,
    error: false,
    valid: true,
    value: '',
    items: [],
    validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PROJECT_TYPE_CODE]
  }
}

// Initial state for filter fields defined outside the component to prevent re-creation for Invoice Management
export const initialFilterFields = {
  searchTerm: {
    name: 'searchTerm',
    label: 'Search',
    type: 'text',
    className: "search-input",
    placeholder: "Invoice #, supplier, or item...",
    value: '',
  },
  supplierId: {
    name: FILTER_KEYS.SUPPLIER,
    label: INVOICE_FILTER_OPTIONS.ALL_SUPPLIERS,
    placeholder: 'Select Supplier',
    type: 'select',
    value: { label: INVOICE_FILTER_OPTIONS.ALL_SUPPLIERS, value: INVOICE_FILTER_OPTIONS.ALL_SUPPLIERS },
    options: [],
  },
  status: {
    name: INVOICE_FILTER_OPTIONS.PAYMENT_STATUS,
    label: INVOICE_FILTER_OPTIONS.PAYMENT_STATUS,
    type: 'select',
    value: { label: INVOICE_FILTER_OPTIONS.ALL_PAYMENT_STATUS, value: INVOICE_FILTER_OPTIONS.ALL_PAYMENT_STATUS },
    options: [
      { label: INVOICE_FILTER_OPTIONS.ALL_PAYMENT_STATUS, value: INVOICE_FILTER_OPTIONS.ALL_PAYMENT_STATUS },
      { label: INVOICE_FILTER_OPTIONS.FULLY_INVOICED, value: INVOICE_FILTER_OPTIONS.FULLY_INVOICED },
      { label: INVOICE_FILTER_OPTIONS.NOT_INVOICED, value: INVOICE_FILTER_OPTIONS.NOT_INVOICED },
      { label: INVOICE_FILTER_OPTIONS.PARTIALLY_INVOICED, value: INVOICE_FILTER_OPTIONS.PARTIALLY_INVOICED },
    ],
  },
  dateRange: {
    name: 'dateRange',
    label: 'Date Range',
    type: 'select',
    value: { label: INVOICE_FILTER_OPTIONS.ALL_TIME, value: INVOICE_FILTER_OPTIONS.ALL_TIME },
    options: [
      { label: INVOICE_FILTER_OPTIONS.ALL_TIME, value: INVOICE_FILTER_OPTIONS.ALL_TIME },
      { label: INVOICE_FILTER_OPTIONS.TODAY, value: INVOICE_FILTER_OPTIONS.TODAY },
      { label: INVOICE_FILTER_OPTIONS.THIS_WEEK, value: INVOICE_FILTER_OPTIONS.THIS_WEEK },
      { label: INVOICE_FILTER_OPTIONS.THIS_MONTH, value: INVOICE_FILTER_OPTIONS.THIS_MONTH },
      { label: INVOICE_FILTER_OPTIONS.LAST_MONTH, value: INVOICE_FILTER_OPTIONS.LAST_MONTH },
      { label: INVOICE_FILTER_OPTIONS.THIS_QUARTER, value: INVOICE_FILTER_OPTIONS.THIS_QUARTER },
      { label: INVOICE_FILTER_OPTIONS.LAST_QUARTER, value: INVOICE_FILTER_OPTIONS.LAST_QUARTER },
      { label: INVOICE_FILTER_OPTIONS.THIS_YEAR, value: INVOICE_FILTER_OPTIONS.THIS_YEAR },
      { label: INVOICE_FILTER_OPTIONS.LAST_YEAR, value: INVOICE_FILTER_OPTIONS.LAST_YEAR },
      { label: INVOICE_FILTER_OPTIONS.LAST_30_DAYS, value: INVOICE_FILTER_OPTIONS.LAST_30_DAYS },
      { label: INVOICE_FILTER_OPTIONS.LAST_90_DAYS, value: INVOICE_FILTER_OPTIONS.LAST_90_DAYS },
      { label: INVOICE_FILTER_OPTIONS.CUSTOM, value: INVOICE_FILTER_OPTIONS.CUSTOM },
    ],
  },
  minAmount: {
    name: 'minAmount',
    label: 'Min Amount',
    type: 'number',
    placeholder: 'Min Amount',
    value: '',
  },
  maxAmount: {
    name: 'maxAmount',
    label: 'Max Amount',
    type: 'number',
    placeholder: 'Max Amount',
    value: '',
  },
  selectedProjectId: { name: FILTER_KEYS.SELECTED_PROJECT, value: null, label: INVOICE_FILTER_OPTIONS.ALL_PROJECTS },
  selectedStageId: { name: FILTER_KEYS.SELECTED_STAGE, value: null, label: null },
  selectedTaskId: { name: FILTER_KEYS.SELECTED_TASK, value: null, label: null },
};